import { ISendActionGet, ISendActionSet } from '@EcamModel/controllers/IPTZCamConfigureRequestHttpController';
import { PTZSnapShotSetting } from '@EcamModel/model/PTZSnapshotSetting';
import { cameraPTZConfigureRequestHttpController } from '@controllers/index';
import { pushError, pushSuccess } from '@components/toast';
import { useState } from 'react';
import { useQuery, useMutation, useQueryClient } from 'react-query';

export enum SectionsCollapsePTZ {
    Basic = 'basic',
    Others = 'others',
    PTZ_OSD = 'PTZ_OSD',

    InitialPosition = 'initialPosition',
    ScheduledTasks = 'scheduledTasks',

    AutoTracking_BasicSettings = 'autoTracking_BasicSettings',
    AutoTracking_ScheduleSettings = 'autoTracking_ScheduleSettings',

    SetTheSystemTime = 'setTheSystemTime',
    CurrentSystemTime = 'currentSystemTime',

    ImageAdjustment = 'imageAdjustment',
    ImageEnhancement = 'imageEnhancement',
    DayNightSwitch = 'day_nightSwitch',
    DayNightParameters = 'day_nightParameters',
    Exposure = 'exposure',
    Backlight = 'backlight',
    WhiteBalance = 'whiteBalance',
    Display = 'display',

    MotionDetection_BasicSettings = 'motionDetection_BasicSettings',
    MotionDetection_ScheduleSettings = 'motionDetection_ScheduleSettings',

    StorageManagement = 'storageManagement',
    RecordSettings = 'recordSettings',
    SnapshotSettings = 'snapshotSettings',

    PrimaryStream = 'primaryStream',
    SecondaryStream = 'secondaryStream',
    TertiaryStream = 'tertiaryStream',
}

export interface LoadingState {
    basicInfoMilesightsPTZ: boolean;
    PTZLimit: boolean;
    PTZAutoTracking: boolean;
    PTZMotionDetection: boolean;
    PTZRecordSetting: boolean;
    PTZScheduledTask: boolean;
    PTZSnapShotSetting: boolean;
    PTZStorageSetting: boolean;
    PTZVideoGeneral: boolean;
    PTZSysDateTime: boolean;
    PTZCameraDayNight: boolean;
    PTZCameraSetting: boolean;
}

type Props = {
    filteredCamera: ISendActionGet;
    cameraPTZ: number;
};

export default function useMileSightPTZ(props: Props) {
    const queryClient = useQueryClient();
    const [isOpenCollapse, setIsOpenCollapse] = useState<{ [key in SectionsCollapsePTZ]: boolean }>({
        basic: true,
        PTZ_OSD: false,
        others: false,
        initialPosition: false,
        scheduledTasks: false,
        day_nightSwitch: false,
        storageManagement: false,
        recordSettings: false,
        snapshotSettings: false,
        autoTracking_BasicSettings: false,
        autoTracking_ScheduleSettings: false,
        backlight: false,
        currentSystemTime: false,
        day_nightParameters: false,
        display: false,
        exposure: false,
        imageAdjustment: false,
        imageEnhancement: false,
        motionDetection_BasicSettings: false,
        motionDetection_ScheduleSettings: false,
        primaryStream: false,
        secondaryStream: false,
        setTheSystemTime: false,
        tertiaryStream: false,
        whiteBalance: false,
    });

    const updateSnapshotSettingsMutation = useMutation(
        (data: Partial<PTZSnapShotSetting>) => {
            if (props?.cameraPTZ) {
                return cameraPTZConfigureRequestHttpController.setPTZSnapShotSetting({
                    ...props.filteredCamera,
                    data: data,
                } as ISendActionSet<PTZSnapShotSetting>);
            }
            throw new Error('Camera PTZ not available');
        },
        {
            onSuccess: () => {
                queryClient.invalidateQueries(['PTZSnapShotSetting', props?.filteredCamera]);
                pushSuccess('Snapshot settings updated successfully');
            },
            onError: (error: any) => {
                pushError('Failed to update snapshot settings');
            },
        }
    );

    return {
        isOpenCollapse,
        setIsOpenCollapse,
        updateSnapshotSettings: updateSnapshotSettingsMutation.mutateAsync,
    };
}
